import React from "react";

const OlaplexHow = () => {
  return (
    <div className="botoxBenefitsContainer">
      <h4>How Olaplex Hair Treatments in Bangalore Work</h4>
      <p>
        The process of Olaplex hair treatments in Bangalore is straightforward
        yet highly effective. It usually involves several steps, each designed
        to maximize the treatment's effectiveness.
      </p>
      <li>
        <h6>1. Bond Multiplier:</h6> The first step involves applying the
        Olaplex Bond Multiplier to your hair. This product works to rebuild the
        broken disulfide bonds in your hair, starting the repair process.
      </li>
      <li>
        <h6>2. Bond Perfector:</h6> The second step is the application of the
        Olaplex Bond Perfector. This step further strengthens and enhances the
        repair process initiated by the Bond Multiplier, ensuring that your hair
        is fully restored.
      </li>
      <li>
        <h6>3. Hair Mask or Conditioning:</h6> After the Olaplex treatment, a
        hair mask or deep conditioning treatment is applied to hydrate and
        nourish your hair. This step ensures your hair is left soft, smooth, and
        shiny.
      </li>
      <li>
        <h6> 4. Styling and Finish:</h6> The final step involves styling your
        hair as desired. Thanks to Olaplex hair treatments in Bangalore, your
        hair will be easier to style and will maintain its shape and texture for
        longer.
      </li>
    </div>
  );
};

export default OlaplexHow;
